export default __webpack_public_path__ + "static/logo-31ebc8d0699ce4aa9cfd4a9feba0ae13.png";